import { render, staticRenderFns } from "./PdNoticeModal.vue?vue&type=template&id=8f8e1d04"
import script from "./PdNoticeModal.vue?vue&type=script&lang=js"
export * from "./PdNoticeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports